import React from 'react';

interface ITimeProps {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

const Time: React.FC<ITimeProps> = props => (
  <svg width="17px" height="17px" viewBox="0 0 17 17" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-244.000000, -338.000000)"
        fill={props.fill || Styles.color.black}
        fillRule="nonzero"
      >
        <g transform="translate(244.500000, 338.500000)">
          <path
            d="M8,0 C3.581722,0 0,3.581722 0,8 C0,12.418278 3.581722,16 8,16 C12.418278,16 16,12.418278 16,8 C16,3.581722 12.418278,0 8,0 Z M8,1 C11.8659932,1 15,4.13400675 15,8 C15,11.8659932 11.8659932,15 8,15 C4.13400675,15 1,11.8659932 1,8 C1,4.13400675 4.13400675,1 8,1 Z"
            id="Oval"
          />
          <path
            d="M8,2.20013136 C8.24545989,2.20013136 8.44960837,2.37700652 8.49194433,2.61025573 L8.5,2.70013136 L8.499,7.499 L11.6562614,7.5 C11.9017213,7.5 12.1058698,7.67687516 12.1482057,7.91012437 L12.1562614,8 C12.1562614,8.24545989 11.9793862,8.44960837 11.746137,8.49194433 L11.6562614,8.5 L8,8.5 C7.75454011,8.5 7.55039163,8.32312484 7.50805567,8.08987563 L7.5,8 L7.5,2.70013136 C7.5,2.42398899 7.72385763,2.20013136 8,2.20013136 Z"
            id="Path-2"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Time;
